import type { WebSocketHookReturn } from '../hooks/useWebSocket'
import { AccountPanel } from '../components/AccountPanel'
import { AdaptiveTuningZone } from '../components/AdaptiveTuningZone'
import { AgentHealth24h } from '../components/AgentHealth24h'
import { AgentHealthGrid } from '../components/AgentHealthGrid'
import { CloudWatchMetrics } from '../components/CloudWatchMetrics'
import { GoalsProgress } from '../components/GoalsProgress'
import { LiveSanityGateFeed } from '../components/LiveSanityGateFeed'
import { LLMAuditList } from '../components/LLMAuditList'
import { LLMBacktestZone } from '../components/LLMBacktestZone'
import { LLMCadenceToggle } from '../components/LLMCadenceToggle'
import { LLMCostTile } from '../components/LLMCostTile'
import { LLMEnvelopeView } from '../components/LLMEnvelopeView'
import { LLMPrecedentList } from '../components/LLMPrecedentList'
import { MLEnsembleStatus } from '../components/MLEnsembleStatus'
import { RiskMonitor } from '../components/RiskMonitor'
import { ServicesStatus } from '../components/ServicesStatus'
import { SignalPipeline } from '../components/SignalPipeline'
import { TaxSummaryCard } from '../components/TaxSummaryCard'
import { TopologyDiagram } from '../components/TopologyDiagram'
import { VetoRateTrends } from '../components/VetoRateTrends'
import '../components/Dashboard.css'

/**
 * Phone body of the operations console: platform-wide (not per-book) zones
 * relocated unchanged from the old Dashboard — signals/models, LLM reasoning,
 * system health, operator tools, and the global tax summary. Desktop renders
 * the DeskGrid modules instead (OpsPage).
 */
export function OpsLegacyBody({ ws }: { ws: WebSocketHookReturn }) {
  return (
    <main className="dashboard-content">
      <section className="dash-zone">
        <h2 className="dash-zone-title">Research book · live feeds</h2>
        <p className="caption">relocated from the fleet view — research book (default), broker-backed</p>
        <div className="dash-zone-grid dash-zone-grid--2">
          <AccountPanel ws={ws} />
          <SignalPipeline ws={ws} />
          <LiveSanityGateFeed ws={ws} />
          <RiskMonitor ws={ws} />
        </div>
        <div className="dash-zone-grid">
          <TopologyDiagram />
        </div>
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">Signals &amp; models</h2>
        <div className="dash-zone-grid dash-zone-grid--3">
          <MLEnsembleStatus />
          <GoalsProgress />
          <VetoRateTrends />
        </div>
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">LLM reasoning</h2>
        <div className="dash-zone-grid dash-zone-grid--3">
          <LLMCostTile />
          <LLMCadenceToggle />
          <LLMEnvelopeView />
        </div>
        <div className="dash-zone-grid dash-zone-grid--2">
          <LLMAuditList />
          <LLMPrecedentList />
        </div>
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">System health</h2>
        <div className="dash-zone-grid dash-zone-grid--2">
          <ServicesStatus />
          <AgentHealthGrid />
          <AgentHealth24h />
          <CloudWatchMetrics />
        </div>
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">Operator tools</h2>
        <LLMBacktestZone />
        <div className="dash-zone-spacer" />
        <AdaptiveTuningZone />
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">Tax</h2>
        <div className="dash-zone-grid dash-zone-grid--3">
          <TaxSummaryCard />
        </div>
      </section>
    </main>
  )
}
